import { Inset, Popover } from "@radix-ui/themes";
import CLASSNAME from "./classname";
import SIZE from "./size";
import { MdOutlineClosedCaption } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import { IoReorderThreeOutline } from "react-icons/io5";
import { TiBusinessCard } from "react-icons/ti";
import { TbFilters } from "react-icons/tb";
import useNewToggle from "../../../../hooks/useNewToggle";

const MenuControl = () => {
  const [isOn, toggleMenu, setIsOn] = useNewToggle();

  return (
    <div className="relative group mobile:hidden">
<Popover.Root open={isOn} onOpenChange={setIsOn}>
        <Popover.Trigger>
          <div
            className="flex h-12 w-12  largescreen:h-14 largescreen:w-14 items-center justify-center rounded-full cursor-pointer"
            style={{
              background: "rgb(95, 72, 138)",
              boxShadow:
                "rgb(152, 122, 209) -8px -8px 16px inset, rgba(2, 2, 2, 0.61) 8px 8px 8px inset",
            }}
            onClick={toggleMenu}
          >
            <IoReorderThreeOutline  color="white" size={SIZE} />
          </div>
        </Popover.Trigger>
        <Popover.Content>
          <Inset>
            <div className="flex flex-col p-2 space-y-4 bg-app-blue">
              <button
                className={`${CLASSNAME} bg-transparent`}
                onClick={toggleMenu}
              >
                <IoMdClose size={SIZE} />
              </button>
              <div className={`${CLASSNAME} bg-white shadow`} onClick={toggleMenu}>
                <MdOutlineClosedCaption color="#5F488A" size={SIZE} />
              </div>
              <div className={`${CLASSNAME} bg-white`} onClick={toggleMenu}>
                <TbFilters color="#5F488A" size={SIZE} />
              </div>
              <div className={`${CLASSNAME} bg-white`} onClick={toggleMenu}>
                <TiBusinessCard color="#5F488A" size={SIZE} />
              </div>
            </div>
          </Inset>
        </Popover.Content>
      </Popover.Root>
      <div className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 max-w-full bg-black text-white text-sm rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        More
      </div>
    </div>
  );
};

export default MenuControl;
